import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";

export default class MemoryGame6 extends React.Component {

      //id elemnt html [ memory-game-6 ]

	constructor(props) {
		super(props);
		this.state = {
			logged: true,
			alreadyPlayed: false,
			remainingTime: document.getElementById("memory-game-6").getAttribute("maxTime") || 90,
			remainingClicks: document.getElementById("memory-game-6").getAttribute("maxClicks") || 10,
			maxClicks: document.getElementById("memory-game-6").getAttribute("maxClicks") || 10,
			started: false,
			ended: false,
			winner: false,
			instantWinner: false,
			instantChecked: false,
			instantChecking: false,
			spottedDifferences: [],
			differences: JSON.parse(document.getElementById("memory-game-6").getAttribute("differences")),
			img1: "",
			img2: "",
			sponsorImage: document.getElementById("memory-game-6").getAttribute("sponsor") || "",
			// frameworks: [ 'yarn','nodejs','grunt','npm' ],
			frameworks: [ 'img-game-1','img-game-2','img-game-3','img-game-4','img-game-5','img-game-6' ],
			duplicatedFrameworks: [],
			randomizedFrameworks: [],
			finalizedFrameworks: [],
			openedFrameworks: []
		}


	}

	componentDidMount() {

		console.log("memoryGame 6 file JS");

		this.startGAME()
		 
		// load game images
		// const img1 = document.getElementById("difference_image_1").innerHTML,
		// 	img2 = document.getElementById("difference_image_2").innerHTML;
		const logged = document.getElementById("memory-game-6").getAttribute("logged") === "true" ? true : false;
		// const logged =   true  ;
		const alreadyPlayed =  document.getElementById("memory-game-6").getAttribute("alreadyPlayed") === "true" ? true : false;

		this.setState({
			logged, alreadyPlayed
		}, () => {
			this.state.differences.forEach(difference => {
				const clickableObj = document.getElementById(difference);
				if(clickableObj)
					clickableObj.addEventListener("click", () => this.clickDifference(difference));
			});
			const svg = document.querySelector(".game-image.clickable svg");
			if(svg)
				svg.addEventListener("click", () => this.chance());
			//autostart
			//this.start();
		});

	}

	start() {
		this.setState({started: true}, () => {
			this.state.differences.forEach(difference => {
				const clickableObj = document.getElementById(difference);
				if(clickableObj)
					clickableObj.addEventListener("click", () => this.clickDifference(difference));
			});
			const svg = document.querySelector(".game-image.clickable svg");
			if(svg)
				svg.addEventListener("click", () => this.chance());
			setInterval(() => {
				if(this.state.started && !this.state.ended)
					if(this.state.remainingTime === 1)
						this.setState({
							remainingTime: this.state.remainingTime - 1,
							started: true,
							ended: true
						}, () => {
							this.end();
						});
					else
						this.setState({
							remainingTime: this.state.remainingTime - 1
						});
			}, 1000);
		});
	}

	end(win = false) {
		let winner = win;
		this.setState({ winner }, () => {
			this.registerPartecipant(winner);
		});
	}






	clickDifference(difference) {
		const { spottedDifferences } = this.state;
		if(!spottedDifferences.includes(difference)) {
			spottedDifferences.push(difference)
			const elem = document.getElementById(difference);
			elem.style.opacity = "1";
			this.setState({spottedDifferences: spottedDifferences}, () => {
				if(this.state.spottedDifferences.length === this.state.differences.length) {
					this.setState({
						started: true,
						ended: true 
					}, () => {
						this.end(true);
					});
				}
			});
		}
	}

	chance() {
		const { remainingClicks } = this.state;
		this.setState({ remainingClicks: remainingClicks - 1 }, () => {
			if(this.state.remainingClicks === 0)
				this.setState({
					started: true,
					ended: true
				}, () => {
					this.end('win');
				});
		});
	}

	shareOn(platform) {
		const url = window.location.href;
		switch(platform) {
			case "facebook": window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(url)+'&t='+encodeURIComponent('Trova anche tu le differenze!'),'sharer','toolbar=0,status=0,width=626,height=436');
				break;
			case "twitter": window.open("https://twitter.com/home?status="+encodeURIComponent(url))
				break;
			case "whatsapp": window.location.href = "whatsapp://send?text=" + encodeURIComponent(url)
				break;
			case "download": window.open(memeUrl)
				break;
		}
	}


	checkInstantWin() {
		if(!this.state.instantChecking) {
			this.setState({
				instantChecking: true
			}, () => {
				this.registerPartecipant(true).then(isWinner => {
					if(isWinner)
						this.setState({
							instantWinner: true,
							instantChecked: true
						});
					else
						this.setState({
							instantWinner: false,
							instantChecked: true
						});
				});
			});
		}
	}

	registerPartecipant(win) {
		return new Promise((resolve, reject) => {
			axios.post(`?winner=${win ? 1 : 0}&instant=1`).then(response => {
				if(response.data == 1)
					resolve(true)
				else
					resolve(false);
			}).catch(e => {
				resolve(false);
			});
		})
	}


	/****************** START METHODS CLASS MEMORY */


	handleClick(name,index) {
		if(this.state.openedFrameworks.length == 2){
			setTimeout(() => {
				this.check()
			},750)
		} else {
			let framework = {
				name,
				index
			}
			let finalizedFrameworks = this.state.finalizedFrameworks
			let frameworks = this.state.openedFrameworks
			finalizedFrameworks[index].close = false
			frameworks.push(framework)
			this.setState({
				openedFrameworks: frameworks,
				finalizedFrameworks: finalizedFrameworks
			})
			if(this.state.openedFrameworks.length == 2){
				setTimeout(() => {
					this.check()
				},750)
			}
		}
	}
	check(){
		let finalizedFrameworks = this.state.finalizedFrameworks
		if((this.state.openedFrameworks[0].name == this.state.openedFrameworks[1].name) && (this.state.openedFrameworks[0].index != this.state.openedFrameworks[1].index)){
			finalizedFrameworks[this.state.openedFrameworks[0].index].complete = true
			finalizedFrameworks[this.state.openedFrameworks[1].index].complete = true

		}else {
			finalizedFrameworks[this.state.openedFrameworks[0].index].close = true
			finalizedFrameworks[this.state.openedFrameworks[1].index].close = true

		}
		this.setState({
			finalizedFrameworks,
			openedFrameworks: []
		})

		this.endgame( () => {
			console.log('ENDGAME WINNER');
			//  onDone
			this.setState({
				remainingTime: this.state.remainingTime - 1,
				started: true,
				ended: true
			}, () => {
				this.end(true);
			});

		});
	}


	//check a fine game
	endgame( callback ){
		let countMatch = 0;
		this.state.finalizedFrameworks.map( (item ) =>{
			if( item.complete ){
				countMatch++;
			}
		});
		if( countMatch == this.state.finalizedFrameworks.length ){
			callback();
		}

	}
	shuffle(array){
		let currentIndex = array.length, temporaryValue, randomIndex;
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex]  = temporaryValue;
		}
		return array
	}
	startGAME(){
		let finalizedFrameworks = [];
		this.state.duplicatedFrameworks = this.state.frameworks.concat(this.state.frameworks)
		this.state.randomizedFrameworks = this.shuffle(this.state.duplicatedFrameworks)
		this.state.randomizedFrameworks.map((name,index) => {
			finalizedFrameworks.push({
				name,
				close: true,
				complete: false,
				fail: false
			})
		})
		this.state.finalizedFrameworks = finalizedFrameworks
	}

	/******************  END  CMETHOD CLASS MEMORY */

	render() {

		const { remainingTime, started, ended, maxClicks, remainingClicks, differences,
			spottedDifferences, img1, img2, winner, sponsorImage, logged, alreadyPlayed,
			instantChecked, instantWinner, instantChecking } = this.state;

		return (
			<Fragment>

				{/* HEADER */}
				<div className={"header"}>
					<div className={"container"}>
						<div className={"logo"} style={{
							background: '#ffffff',
							borderRadius: '21px',
							padding:'10px 0px',
							maxWidth: '300px',
							margin: '0 auto',
						}} >
							<img  style={{
							width:'110px'
						}} src={ASSETS_BASE + "/images/memoryGame6/LogoPurina_Felix.png"} alt={'sponsor'}/> 
						</div>
					</div>
				</div>

				{/* GAME CANVAS */}
				<div className={"game-canvas"}>

					{/* {alreadyPlayed && (
						<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
							<h4 style={{color: "#ffffff", fontWeight: "bold", marginTop: "2em", textAlign: "center"}}>Hai già partecipato a questo gioco!</h4>
						</div>
					)} */}

					{!started && !ended && !logged  &&(
						<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
							<button id={"accedi_registrati_btn"} style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "50%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
								Accedi / Registrati per giocare!
							</button>
						</div>
					)}

					{!started && !ended && logged && (
						<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
							<button id={"start_game_btn"} style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "50%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => this.start()} >
								Clicca per far partire il tempo e iniziare a giocare!
							</button>
						</div>
					)}

					{started && !ended  && (
						<div className={"container"}>

							<div className={"flex j-center a-center"} style={{justifyContent: "center!important"}}>
								<div className={"time flex j-center a-center"}>
									<img className={"time-icon"} src={ASSETS_BASE + "/images/time.png"} style={{fontSize:'25px',marginRight:'10px'}}/>
									<span className={"time-remaining"} style={{color:'#ffffff'}}>
										TEMPO RESIDUO
										<strong style={{fontSize:'25px'}} >
											<Timer started={started} remainingTime={remainingTime} />
										</strong>
									</span>
								</div>
							</div>

							<div className="playground">
								{
									this.state.finalizedFrameworks.map((framework, index) => {
										return <Card key={index} framework={framework.name} click={() => {
											this.handleClick(framework.name,index)}} close={framework.close} complete={framework.complete}/>
									})
								}
							</div>

							{/* <h4 className={"d-none d-md-block"}>Clicca su questa immagine per trovare le differenze</h4>
							<div className={"row diff-images-wrapper w-100"}>
								<div className={"col-md-6 col-xs-12"}>
									<div className={"game-image"} dangerouslySetInnerHTML={{__html: img1 }} />
								</div>
								<div className={"col-md-6 col-xs-12"}>
									<h4 className={"d-md-none d-xs-block"} style={{textAlign: "left"}}>Clicca su questa immagine per trovare le differenze</h4>
									<div className={"game-image clickable"} dangerouslySetInnerHTML={{__html: img2 }} />
								</div>
							</div> */}
						</div>
					)}

					{/* Ha vinto il gioco, non ha provato l'instant win */}
					{started && ended && winner  && (
						<div className={"game-result-banner container"}>
							<h3 style={{ color:'#ea2327' }}>WOW! SEI UN LAMPO!</h3>
							<p style={{ fontSize:'19px' }}>Hai trovato tutte le coppie nel tempo a disposizione.  
							Grazie per aver partecipato, ecco <b style={{ fontWeight:'bold!important'  }} >il codice sconto da utilizzare 
							su purinashop.it:</b>  <b style={{ fontWeight:'bold !important', color:'red' }}>FELIXMEMORY10.</b>
							Il buono sconto ti da diritto a uno sconto del <b style={{ fontWeight:'bold!important'  }} >10% sull’acquisto di prodotti Felix sul sito Purinashop.it</b>, 
							il buono sconto è valido fino al <b style={{ fontWeight:'bold!important'  }} >28/02/2021</b>.
							</p>
							<p>
							<a href={'https://www.purinashop.it/brand/gatto/felix'} className={'btn play-game-button btn-purinashop'}> VAI AL PURINASHOP</a>
							<a  onClick={()=>{
									window.location.reload();
								}} className={'btn play-game-button btn-purinagiocadinuovo'}> GIOCA DI NUOVO </a>

							</p>
							 
							{/* <button disabled={instantChecking} className={'btn play-game-button btn-condividi'} onClick={() => this.checkInstantWin()} >CLICCA QUI PER SCOPRIRE SE HAI VINTO</button><br/> */}
							<img style={{maxWidth: "100%"}} src={ASSETS_BASE + "/images/memoryGame6/img-popup-win.png"} />
						</div>
					)}

					{/* Ha vinto l'instant win */}
					{/* {started && ended && winner && instantChecked && instantWinner && !alreadyPlayed && (
						<div className={"game-result-banner container"}>
							<h3>COMPLEMENTI, OGGI E’ UN GIORNO FORTUNATO!</h3>
							<p>Hai vinto un prodotto omaggio PURINA® GOURMET™ per il tuo gatto. Riceverai presto una mail con il dettaglio della vincita.</p>
							<button onClick={() => this.shareOn("facebook")} className={"btn play-game-button"}>Condividi il gioco</button><br/>
							<img style={{maxWidth: "100%"}} src={ASSETS_BASE + "/images/cat.png"} />
						</div>
					)} */}

					{/* Ha perso l'instant win */}
					{/* {started && ended && winner && instantChecked && !instantWinner && !alreadyPlayed && (
						<div className={"game-result-banner container"}>
							<h3>PECCATO, NON SEI STATO FORTUNATO.</h3>
							<p>Gioca di nuovo e tenta la fortuna, ogni giorno, fino al 22/12/2020, puoi provare a vincere un omaggio PURINA® GOURMET™ per il tuo gatto!</p>
							<button onClick={() => window.location.reload()} className={"btn play-game-button"}>Torna al gioco</button><br/>
							<img style={{maxWidth: "100%"}} src={ASSETS_BASE + "/images/cat.png"} />
						</div>
					)} */}

					{/* Ha perso il gioco */}
					{started && ended && !winner && (
						<div className={"game-result-banner container"}>
							<h3 style={{ color:'#ea2327' }}>GRAZIE PER AVER GIOCATO CON NOI!</h3>
							<p style={{ fontSize:'19px' }}>
								Ecco <b style={{ fontWeight:'bold!important'  }} > il codice sconto da utilizzare su purinashop.it:</b> <b style={{ fontWeight:'bold !important', color:'red' }}>FELIXMEMORY10</b>.  
								Il buono sconto ti da diritto a uno sconto 
								del <b style={{ fontWeight:'bold!important'  }} >10% sull’acquisto di prodotti Felix sul sito Purinashop.it</b>, 
								il buono sconto è valido fino al <b style={{ fontWeight:'bold!important'  }} >28/02/2021</b>.
							</p>
							<p>
								<a href={'https://www.purinashop.it/brand/gatto/felix'}  className={'btn play-game-button btn-purinashop'}> VAI AL PURINASHOP</a>
								<a onClick={()=>{
									window.location.reload();
								}} className={'btn play-game-button btn-purinagiocadinuovo'}> GIOCA DI NUOVO </a>

							</p>
							
							<img style={{maxWidth: "100%"}} src={ASSETS_BASE + "/images/memoryGame6/Felix_Isolated2.png"} />
						</div>
					)}

				</div>

			</Fragment>
		);
	}

}

const Timer = ({ remainingTime }) => {
	const mins = Math.floor(remainingTime/60) < 10 ? `0${Math.floor(remainingTime/60)}` : Math.floor(remainingTime/60);
	const secs = (remainingTime%60) < 10 ? `0${(remainingTime%60)}` : (remainingTime%60);
	return (
		<Fragment>
			{mins}:{secs}
		</Fragment>
	);
}


class Card extends React.Component {
	constructor(props) {
		super(props)
		this.state = { }
	}
	clicked(framework){
		this.props.click(framework)
	}
	render(){
		return (
			<div className={"card" + (!this.props.close ? ' opened' : '') + (this.props.complete ? ' matched' : '')} onClick={() => this.clicked(this.props.framework)}>
				<div className="front">
					{/* ? */}
					<img className={'front-card-image'}  src={ASSETS_BASE + "/images/memory/front-card.png"} />
				</div>
				<div className="back">
					<img src={ ASSETS_BASE + "/images/memoryGame6/" + this.props.framework + ".png"}/>

					{/* ASSETS_BASE + "/images/front-card.png */}
					{/* <img src={"https://raw.githubusercontent.com/samiheikki/javascript-guessing-game/master/static/logos/" + this.props.framework + ".png"}/> */}
				</div>
			</div>
		)
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const mountPoint = document.getElementById("memory-game-6");
	if(mountPoint)
		ReactDOM.render(<MemoryGame6 />, mountPoint);
});
